module.exports = __webpack_public_path__ + "static/media/download-pajoohyar-banner.f5add8e0.png";